module.exports = __webpack_public_path__ + "static/media/afterglow-back-view-dawn-2825791.4d8aa304.png";